
import Pusher from "@/common/mixins/live-echo-mixin"

export default {
    mixins: [Pusher],
    data() {
        return {
            content_ready: false,
            single: null,
            error: null,
            mode: 'WAIT',
            state: 1,
            timer: 0,
            public_comments: [],
            self_comments: [],
            source: null,
            old_mode: '',
            show_poster:true,
            title:null,
        }
    },
    mounted() {
        /* 每分钟都要做reload不需要了，走socket 未完成，还是先用每分钟load方式 */
        const vm = this;
        this.timer = setInterval(function () {
            vm.reload();
        }, 60000);
        /*   ----    */
        this.source = localStorage.getItem('PLAY_SOURCE');
        this.reload();
    },
    computed: {
        status() {
            return this.getStatus(this.single.start_timestamp, this.single.end_timestamp);
        }
    },
    methods: {
        getStatus(start_timestamp, end_timestamp) {
            let ret = 0;
            if (this.single) {
                const start = start_timestamp;
                const end = end_timestamp;
                const now = new Date().getTime() / 1000;
                if (start > now) ret = 0;
                else if (now > end) ret = 2;
                else ret = 1;
            }
            return ret;
        },
        afterReload(){
            //do something update
            if (this.title) {
                this.$title(this.title);
            }
        },
        reload() {
            const vm = this;
            const passcode = localStorage.getItem(this.$route.params.id + '_passcode');
            const status = this.single ? this.status : -1;
            if (this.old_mode !== this.mode) this.state = 1;
            this.old_mode = this.mode;
            this.$api('PROGRAM.PLAY', {
                uuid: this.$route.params.id,
                passcode: passcode,
                state: this.state,
                source: this.source,
                status: status
            }).then(res => {
                if (res.data.success) {
                    const program = res.data.data;
                    if (!this.single ||
                        program.description !== this.single.description ||
                        program.start_timestamp !== this.single.start_timestamp ||
                        program.end_timestamp !== this.single.end_timestamp ||
                        program.close_action !== this.single.close_action ||
                        program.dvr_file !== this.single.dvr_file || !this.content_ready
                    ) {
                        vm.$set(this, 'single', program);
                        let old_mode = this.mode;
                        if (this.status === 0) this.mode = 'WAIT';
                        else if (this.status === 1) this.mode = 'PLAY';
                        else this.mode = "END"
                        this.content_ready = true;

                        if (old_mode !== this.mode) {
                            old_mode = this.mode;
                            this.mode = "";
                            this.$nextTick(() => {
                                this.mode = old_mode;
                            })
                        }
                    }

                    //** update Comments
                    if (program.comments) { //
                        this.updateComments(program.comments);
                    }
                    this.single.comments = null;
                    this.$set(this.single, 'online', program.online);

                    //** start socket channel
                    if (program.channel) {
                        //this.initPusher(program.channel);
                    }

                } else {
                    vm.error = res.data.text;
                    if (vm.error === "MUST-SIGN-IN") {
                        vm.$router.push({name: 'sign-in', query: {_t: encodeURIComponent(vm.$route.path),_sso:vm.$organization.sso}})
                    }
                    vm.content_ready = false;
                    vm.single = res.data.data;
                }
                this.state = 2
                this.title = this.single.subject;
                this.afterReload();
            });

        },
        updateCommentBox(){
        },
        updateComments(comments) {
            const vm = this;
            const pc = comments.public;
            if (!this.public_comments || this.public_comments.length !== pc.length) {
                vm.$set(this, "public_comments", pc);
                vm.updateCommentBox();
            } else {
                for (let i = 0; i < pc.length; i++) {
                    if (this.public_comments[i].text !== pc[i].text) {
                        vm.$set(this, "public_comments", pc);
                        vm.updateCommentBox();
                        break;
                    }
                }
            }
            const sc = comments.self;
            if (!this.self_comments || this.self_comments.length !== sc.length) {
                vm.$set(this, "self_comments", sc);
            } else {
                for (let i = 0; i < sc.length; i++) {
                    if (!this.self_comments[i] || this.self_comments[i].text !== sc[i].text || this.self_comments[i].answer !== sc[i].answer) {
                        vm.$set(this, "self_comments", sc);
                        return;
                    }
                }
            }
        },
        handlePasscode(passcode) {
            localStorage.setItem(this.$route.params.id + '_passcode', passcode);
            this.reload();
        },
        handlePlayFromWait() {
            this.mode = "";
            this.$nextTick(() => {
                this.mode = "PLAY";
            })
        },
        handleEndFromPlay() {
            this.mode = "";
            this.$nextTick(() => {
                this.mode = "END";
            })
        },
        handleSourceUpdate(source) {
            this.source = source;
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$api('PROGRAM.PLAY', {
            uuid: this.$route.params.id,
            closed: 1,
            state: this.state,
            source: this.source
        });
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = 0;
        }
        this.disconnectPusher();
        next();
    },
}
